import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import "./style.css";
import { Breadcrumb, PopUpModal, Timeline, Title, VehicleLockUnlockModal, StatsCard, SuccessPopupModal } from '../../Components/Atoms';
import { Button, IconButton, Switch, Tooltip, useToast } from '@chakra-ui/react';
import { getISODate, getLocalisedDate, getLocalisedTime, secondsToHms } from '../../Library/datetime';
import { DATASET_COLORS } from '../../Assets/styles/colors';
import SuccessModal from '../../Components/Atoms/SuccessModal';
import BatterySwappingModal from '../../Components/Atoms/BatterySwappingModal';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import StatCard from '../../Components/Molecules/StatCard';
import { getAllRideStats, getDriverOrVehicleStats, getUserAndVehicleDetails, getVehiclesInfo, manageVehicles, removeVehicle, swapBattery, unassignDriver, getUserSubsWarrantyDetails } from '../../APIs';
import { generateDatasetForDays } from '../../Library/widgets';
import Loader from '../Loader';
import { StoreContext } from '../../Library/contexts';
import PATHS from "../../Routes/paths";
import { CO2_EMISSION_PER_KM, CONNECTOR_TYP_REV_MAP, DATE_OPTIONS, DATE_RANGES, DEVICE_HWTYP_VALUES, DEVICE_HWTYPS, DRAWER_ACCESS_CODES, FUEL_TYPES, MANUFATURING_CO2_EMISSION_PER_KM, VOLTAGE_LEVEL_MAP } from '../../Library/constants';
import { EditModelIcon, InfoIconBgFilled, LockIcon, UnlockIcon } from '../../Assets/images/svgs';
import { TodayRide } from '../../Components/Organisms';
import { RidingScore } from '../../Widgets';
import { DatePicker } from '../../Components/Molecules';
import { ellipsisify, getItemFromLocalStorage, transformUserDetails, getDaysLeft, getStatusPill } from '../../Library/helpers';

const VehicleStats = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const vehicle = queryParams.get('idx');
  const isAssigned = +queryParams.get("assigned");
  const userRef = useRef(false);
  const isStatsFetchedRef = useRef(false);
  const isSellerOrDealer = useRef(getItemFromLocalStorage("des"));
  const liveTracking = useRef(queryParams.get("liveTracking") === "true");
  const isDm = useRef(queryParams.get("isDm") === "true");

  const Toast = useToast();
  const navigate = useNavigate();

  const { filters, userVehicles, allSubUsers, setAllSubUsers, setUserVehicles } = useContext(StoreContext);

  const [ showSwappingModal, setShowSwappingModal ] = useState(false);
  const [ showSuccessModal, setShowSuccessModal ] = useState(false);
  const [ showVehLockUnlockModel, setShowVehLockUnlockModel] = useState(false);
  const [ newBattery, setNewBattery ] = useState("");
  const [ modalError, setModalError ] = useState("");

  const [ vehicleDetails, setVehicleDetails ] = useState({});
  const [ swappingHistory, setSwappingHistory ] = useState([]);
  const [ vid, setVid ] = useState(null);
  const [ subsWarrantyInfo, setSubsWarrantyInfo ] = useState(null);

  const [ vehicleStats, setVehicleStats ] = useState([]);
  const [ lockStatus, setLockStatus ] = useState(false);

  const [ avgDistanceStats, setAvgDistanceStats ] = useState({});
  const [ avgTimeStats, setAvgTimeStats ] = useState({});
  const [ avSpeedStats, setAvsSpeedStats ] = useState({});

  const [ confirmUnassign, setConfirmUnassign ] = useState(false);
  const [ showRemoveVehicleFromLeaseModal, setShowRemoveVehicleFromLeaseModal ] = useState(false);

  const [ showLoading, setShowLoading ] = useState(true);
  const [ isLockUnlockUpdating, setIsLockUnlockUpdating ] = useState(true);

  const [ avsEmissionStats, setAvsEmissionStats ] = useState(true);

  const [ updateCarbonEmissionConstant, setUpdateCarbonEmissionConstant ] = useState(false);
  const [ isSpecificVehicleStats, setIsSpecificVehicleStats ] = useState(true);
  const [isLt, setIsLt] = useState(false);
  const [stats, setStats] = useState({});
  const [modalMsg, setModalMsg] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [ searchParams, setSearchParams ] = useSearchParams();
  const [ showUnassign, setShowUnassign ] = useState(false);
  const [ lastSeen, setLastSeen ] = useState({});
  const lastSeenRef = useRef();

  const prevUserVehicles = useRef([]);
  const prevFilterRange = useRef(0);
  const selectedSubUser = useRef(allSubUsers.find(subuser => subuser.mob === isAssigned));

  let graphCards = [];

  let vehicleNumber = vehicleDetails && vehicleDetails.reg ? vehicleDetails.reg : vehicle;

  const breadcrumbPaths = [
    { idx: 1, name: "Lease", link: PATHS.LEASE },
    { idx: 2, name: "Vehicles", link: PATHS.LEASED_VEHICLES },
    { idx: 3, name: vehicleNumber, isCurrentPage: true },
  ];

  const statsBreadcrumbPaths = [
    { idx: 1, name: "Statistics", link: `${PATHS.ALL_VEHICLE_STATS}` },
    { idx: 2, name: `${isDm.current ? vehicleDetails.imei : vehicleDetails.reg}`, isCurrentPage: true },
  ]

  const liveTrackingBreadcrumbPaths = [
    { idx: 1, name: "Live Tracking", link: `${PATHS.LIVE_TRACKING}` },
    { idx: 2, name: `${vehicleDetails.reg || "-"}`, isCurrentPage: true },
  ]

  const liveTrackingVehicleStatsBreadcrumbPaths = [
    { idx: 1, name: "Live Tracking", link: `${PATHS.LIVE_TRACKING}` },
    { idx: 2, name: `${liveTracking.current ? "Device Details" : (vehicleDetails.reg || "-")}`, link: liveTracking.current ? `${PATHS.LIVE_TRACKING}/${PATHS.SPECIFIC_DEVICE}?imei=${vehicleDetails.imei}&idx=${vehicleDetails.idx}&lt=true&showButtons=true&liveTracking=true` : `${PATHS.LIVE_TRACKING}/${PATHS.VEHICLE_STATS}?idx=${vehicle}&lt=true` },
    { idx: 3, name: "Statistics", isCurrentPage: true },
  ]

  const subUsersBreadcrumbPaths = [
    { idx: 1, name: "Subusers", link: `${PATHS.SUB_USERS}` },
    { idx: 2, name: selectedSubUser.current?.nm || isAssigned, link: `${PATHS.SUB_USERS}/${PATHS.SUB_USER_DETS}?mob=${isAssigned}` },
    { idx: 3, name: `${vehicleDetails.reg || "-"}`, isCurrentPage: true },
  ];

  const getBreadcrumbPaths = () => {
    if ((isSpecificVehicleStats && isLt) || liveTracking.current) return liveTrackingVehicleStatsBreadcrumbPaths;
    if (isSpecificVehicleStats && !isLt) return statsBreadcrumbPaths;
    if (isAssigned) return subUsersBreadcrumbPaths;
    if (isLt) return liveTrackingBreadcrumbPaths;
    return breadcrumbPaths;
  }

  const fetchVehicles = (clientId, vid) => {
    getVehiclesInfo(clientId, vid, (err, resp) => {
      if (err) {
        console.error(err);
      } else {
        if (resp && resp.length) {
          setVehicleDetails(old => { return { ...old, ...resp[0] } });

          let vehMap = new Map();
          resp.forEach(vehicle => vehMap.set(vehicle.idx, vehicle))

          if (resp[0].swapHist) setSwappingHistory(resp[0].swapHist);
          if (resp[0].idx) setVid(resp[0].idx);
          if (resp[0].rls || resp[0].rls === 0) setLockStatus(Boolean(resp[0].rls))
        }
      }
    });
  }

  const computeStats = (data) => {
    let distanceTravelled = 0;
    let duration = 0;
    let averageSpeed = 0;
    let avgRidingScore = 0;
    let harshAcceleration = 0;
    let overspeed = 0;
    let sharpTurn = 0;
    let suddenBrake = 0;
    let topSpeed = 0;

    data.forEach((stat) => {
      distanceTravelled += stat.dst || 0;
      duration += stat.dur || 0;
      averageSpeed += stat.avs || 0;
      topSpeed = Math.max(topSpeed, stat.tps);

      avgRidingScore += stat.rideScore || 0;
      if(stat.rideScoreCounts){
        harshAcceleration += stat.rideScoreCounts.HARSH_ACCELERATION;
        overspeed += stat.rideScoreCounts.OVERSPEED;
        sharpTurn += stat.rideScoreCounts.SHARP_TURN;
        suddenBrake += stat.rideScoreCounts.SUDDEN_BRAKE;
      }
    });

    avgRidingScore = avgRidingScore / data.length;
    let ridingScoreData = { rideScore: avgRidingScore, rideScoreCounts: { HARSH_ACCELERATION: harshAcceleration, OVERSPEED: overspeed, SHARP_TURN: sharpTurn, SUDDEN_BRAKE: suddenBrake } };
    setStats({
       dst: distanceTravelled,
       dur: duration,
       avs: averageSpeed / data.length,
       tps: topSpeed,
       ridingScoreDetails: ridingScoreData
     });
  };

  const getVehicleStats = (vehicleId) => {
    getDriverOrVehicleStats(vehicleId, null, null, (err, resp) => {
      if (err) {
        console.error(err);
      } else {
        computeStats(resp.dayWiseStats);
        setVehicleStats(resp.dayWiseStats);
        if (resp.overallStats) {
          if (resp.overallStats.totalDst) setAvgDistanceStats({ lifeTimeDist: resp.overallStats.totalDst });
          if (resp.overallStats.totalDur) setAvgTimeStats({ lifeTime: resp.overallStats.totalDur ?? 0 });
          if (resp.overallStats.tps) setAvsSpeedStats({ lifeTimeTopSpeed: resp.overallStats.tps });
          if (resp.overallStats.totalDst) setAvsEmissionStats({ lifeTimeEmission: resp.overallStats.totalDst });
        }
      }
      setShowLoading(false);
    })
  }

  const getSelectedVehicleStats = (vehicleId) => {
    let request = { from: DATE_RANGES[filters.range].from, to: DATE_RANGES[filters.range].to, vids: [vehicleId], getOverallStats: true };
    getAllRideStats(request, (err, data) => {
      if (err) {
        console.error("Error fetching ride stats", err);
      } else {
        if (data && data.dailyRidesStats && data.dailyRidesStats.length) {
          computeStats(data.dailyRidesStats, true);
          setVehicleStats(data.dailyRidesStats);
          if (data.overallStats) {
            if (data.overallStats.totalDst) setAvgDistanceStats({ lifeTimeDist: data.overallStats.totalDst });
            if (data.overallStats.totalDur) setAvgTimeStats({ lifeTime: data.overallStats.totalDur ?? 0 });
            if (data.overallStats.tps) setAvsSpeedStats({ lifeTimeTopSpeed: data.overallStats.tps });
          }
        } else setVehicleStats([]);
      }
      setShowLoading(false);
    });
  }

  const handleFetchedVehicles = (vehicles, singleVehicle) => {
    if (singleVehicle) {
      getSelectedVehicleStats(+vehicles);
    } else {
      if (!vehicles || !vehicles.length) return;
      let selectedVehicle = vehicles.find(veh => veh.idx === Number(vehicle));
      if (selectedVehicle?.dev?.rls || selectedVehicle?.dev?.rls === 0) setLockStatus(Boolean(selectedVehicle?.dev?.rls));
      if (lastSeenRef.current) selectedVehicle.lastSeen = lastSeenRef.current;
      setVehicleDetails(selectedVehicle);
      setShowLoading(false);

      isStatsFetchedRef.current = true;
      getSelectedVehicleStats(selectedVehicle.idx);
    }
  }

  const areUserVehiclesUpdated = (prevVehicles, newVehicles) => {
    if (!prevVehicles || !newVehicles) return false;
    if (prevVehicles.length !== newVehicles.length) return true;
    return false;
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const vid = searchParams.get("idx");
    const isSvs = searchParams.get("isSvs");
    const lt = searchParams.get("lt");

    if (lt) setIsLt(true);
    if (isSvs) setIsSpecificVehicleStats(true);
    else setIsSpecificVehicleStats(false);
    if (!vid)  navigate(`${PATHS.LEASED_VEHICLES}`);

    const storedUser = window.localStorage.getItem("user");
    if (storedUser) {
      try {
        userRef.current = JSON.parse(storedUser);
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }

    if (!userRef.current) {
      if (!isSellerOrDealer.current) {
        fetchVehicles(null, vid);
        getVehicleStats(vid);
      } else {
        fetchVehicles(null, vid);
        handleFetchedVehicles(vid, true);
      }
    } else {
      if (areUserVehiclesUpdated(prevUserVehicles.current, userVehicles) || prevFilterRange.current !== filters.range) {
        prevFilterRange.current = filters.range;
        prevUserVehicles.current = userVehicles;
        if (!isStatsFetchedRef.current || (isStatsFetchedRef.current && filters.range !== DATE_OPTIONS.CUSTOM)) {
          handleFetchedVehicles(userVehicles);
        }
      }
    }
  }, [ navigate, userVehicles, filters.range ])

  const handleUnassignDriver = () => {
    const unsassignVehicle = () => {
      unassignDriver(vehicleDetails.idx, (error) => {
        if (error) {
          console.error(error);
          Toast({ isClosable: true, description: error, position: "bottom", status: "error", variant: "solid" });
        } else {
          setConfirmUnassign(null);
          setVehicleDetails((old) => ({ ...old, dNm: null }));
          Toast({ isClosable: true, description: "Driver Unassigned Successfully", position: "bottom", status: "success", variant: "solid" });
        }
      });
    };

    setConfirmUnassign({
      open: true,
      modalMsg: "Are you sure you want to unassign driver from this vehicle?",
      confirmBtn: "Yes",
      closeBtn: "Cancel",
      onConfirm: () => unsassignVehicle(vehicleDetails.idx),
      onModalClose: () => setConfirmUnassign(null),
    });
  };

  const GetAssignDriverButton = ({ driver }) => {
    if (driver) {
      return (
        <span> {driver}<br />
          <Button onClick={handleUnassignDriver} className='assign-vehicle'>Unassign</Button>
        </span>
      )
    }

    return (
      <span>Not Assigned<br />
        <Button onClick={() => navigate(`${PATHS.LEASE}/${PATHS.DRIVERS}?vid=${vehicle}`)} className='assign-vehicle'>Assign a driver</Button>
      </span>
    )
  }

  const getVehicleDetail = () => {
    let veh = userVehicles.find(veh => veh.idx === +vehicle);
    if (veh && veh.dev && veh.dev.imei) return veh.dev.imei;

    return "-";
  }

  const vehicleDetailLeft = [
    { label: "Registration Number", value: vehicleDetails.reg },
    { label: "Vehicle Color", value: vehicleDetails.clrNm },
    { label: "Ajjas IMEI", value: vehicleDetails.imei },
    { label: "Charger Type", value: CONNECTOR_TYP_REV_MAP[vehicleDetails.cTyp] || "-" },
    { label: "Assigned Driver", value: <GetAssignDriverButton driver={vehicleDetails.dNm} /> },
  ]

  const vehicleDetailRight = [
    { label: "Chassis Number", value: vehicleDetails.chNum },
    { label: "Vehicle Model", value: vehicleDetails.mo },
    { label: "Motor Number", value: vehicleDetails.mtrNum },
    { label: "Battery Number", value: <Link to={`${PATHS.BATTERIES}/${vehicleDetails.bId}`} className='assign-vehicle'>{vehicleDetails.bId}</Link> },
  ]

  const vehicleDetail = [
    { label: "Registration Number", value: vehicleDetails.reg },
    { label: "Vehicle Color", value: vehicleDetails.clrNm },
    { label: "Ajjas IMEI", value: vehicleDetails.imei },
    { label: "Charger Type", value: CONNECTOR_TYP_REV_MAP[vehicleDetails.cTyp] || "-" },
    { label: "Assigned Driver", value: <GetAssignDriverButton driver={vehicleDetails.dNm} /> },
    { label: "Chassis Number", value: vehicleDetails.chNum },
    { label: "Vehicle Model", value: vehicleDetails.mo },
    { label: "Motor Number", value: vehicleDetails.mtrNum },
    { label: "Battery Number", value: <Link to={`${PATHS.BATTERIES}/${vehicleDetails.bId}`} className='assign-vehicle'>{vehicleDetails.bId}</Link> },
  ];

  const addTooltip = (label, value) => {
    return (
      <Tooltip label={label}>
        {value}
      </Tooltip>
    );
  }

  const getBatteryStatus = (lastseen, devtype) => {
    if (lastSeen && lastSeen.heartbeat) {
      if (!devtype || devtype === DEVICE_HWTYPS.Wired || devtype === DEVICE_HWTYPS.Lite) return (lastseen.heartbeat.externalVolt ? addTooltip("Vehicle's Battery Voltage", `${lastseen.heartbeat.externalVolt}V`) : "-");
      else if (devtype === DEVICE_HWTYPS.Wireless) {
        if (lastseen.heartbeat.voltLvlInPercent) return addTooltip("Device's Battery Percentage", `${lastseen.heartbeat.voltLvlInPercent}%`);
        else if (lastseen.heartbeat.voltLvl) return addTooltip(`${VOLTAGE_LEVEL_MAP[lastseen.heartbeat.voltLvl]}. Battery percentage is not available at the moment`, `${ellipsisify(VOLTAGE_LEVEL_MAP[lastseen.heartbeat.voltLvl], 12)}`);
      }
    }
  }

  var vehicleStatsDetails = [
    { label: "Registration Number", value: vehicleDetails.reg },
    // { label: "Vehicle Color", value: vehicleDetails.clrNm || "-" },
    { label: "Vehicle Model", value: vehicleDetails.mo, isUserOnly: true },
    { label: "Device Type", value: vehicleDetails.hwtyp || 1, constants: DEVICE_HWTYP_VALUES, isUserOnly: true },
    { label: "Fuel Type", value: vehicleDetails.ftyp, constants: FUEL_TYPES, isUserOnly: true },
    { label: "Vehicle Model", value: vehicleDetails.mo, isSellerOnly: true },
    { label: "Device Type", value: vehicleDetails.hwtyp || 1, constants: DEVICE_HWTYP_VALUES, isSellerOnly: true },
    { label: "Fuel Type", value: vehicleDetails.ftyp, constants: FUEL_TYPES, isSellerOnly: true },
    { label: "Subuser", value: (selectedUser && selectedUser.fn) || "NA", constants: FUEL_TYPES, isAssignOnly: true },
    { label: "Battery Status", value: vehicleDetails.lastSeen ? getBatteryStatus(vehicleDetails.lastSeen, vehicleDetails.hwtyp) : "-" },
  ];

  if (subsWarrantyInfo?.subscriptionExpiry) {
    const subDays = getDaysLeft(subsWarrantyInfo.subscriptionExpiry);
    const dateStr = new Date(subsWarrantyInfo.subscriptionExpiry).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    vehicleStatsDetails.push({
      label: "Subscription Expiry",
      value: <span className={subDays > 0 ? "bs-sub-date" : "bs-sub-date expired"}>{dateStr}</span>,
    });
  }

  if (isSellerOrDealer.current) {
    vehicleStatsDetails.unshift({ label: "IMEI", value: getVehicleDetail() });
    vehicleStatsDetails.push({ label: "Chassis Number", value: ((vehicleDetails && vehicleDetails.chNum) || "-") });
    vehicleStatsDetails = vehicleStatsDetails.filter(dets => !dets.isUserOnly);
  }

  const TimelineCard = ({ oldBid, newBid, batterySoc, swappedBatterySoc, ts }) => {
    if (!ts) ts = Date.now();
    let formattedDate = `(${getLocalisedDate(ts, true)} at ${getLocalisedTime(ts, true)})`;

    return (
      <div className='timeline-card-cont'>
        <div className='battery-row'>
          <p className='red battery'>
            { oldBid || "" }
            { batterySoc ? <p className='soc'> SOC: {batterySoc} </p> : null}
          </p>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.52934 6.52692C7.66182 6.38474 7.73394 6.1967 7.73052 6.00239C7.72709 5.80809 7.64838 5.62271 7.51096 5.48529C7.37355 5.34788 7.18816 5.26917 6.99386 5.26574C6.79956 5.26231 6.61151 5.33444 6.46934 5.46692L4.46934 7.46692C4.32889 7.60754 4.25 7.79817 4.25 7.99692C4.25 8.19567 4.32889 8.38629 4.46934 8.52692L6.46934 10.5269C6.538 10.6006 6.6208 10.6597 6.7128 10.7007C6.8048 10.7417 6.90411 10.7637 7.00482 10.7655C7.10552 10.7673 7.20555 10.7488 7.29894 10.711C7.39233 10.6733 7.47716 10.6172 7.54838 10.546C7.6196 10.4747 7.67574 10.3899 7.71346 10.2965C7.75118 10.2031 7.76971 10.1031 7.76793 10.0024C7.76615 9.90169 7.74411 9.80238 7.70312 9.71038C7.66213 9.61838 7.60303 9.53558 7.52934 9.46692L6.80934 8.74692H16.9993C17.1983 8.74692 17.389 8.6679 17.5297 8.52725C17.6703 8.38659 17.7493 8.19583 17.7493 7.99692C17.7493 7.798 17.6703 7.60724 17.5297 7.46659C17.389 7.32593 17.1983 7.24692 16.9993 7.24692H6.80934L7.52934 6.52692ZM16.4693 13.4669C16.3289 13.6075 16.25 13.7982 16.25 13.9969C16.25 14.1957 16.3289 14.3863 16.4693 14.5269L17.1893 15.2469H6.99934C6.80043 15.2469 6.60966 15.3259 6.46901 15.4666C6.32836 15.6072 6.24934 15.798 6.24934 15.9969C6.24934 16.1958 6.32836 16.3866 6.46901 16.5272C6.60966 16.6679 6.80043 16.7469 6.99934 16.7469H17.1893L16.4693 17.4669C16.3957 17.5356 16.3366 17.6184 16.2956 17.7104C16.2546 17.8024 16.2325 17.9017 16.2307 18.0024C16.229 18.1031 16.2475 18.2031 16.2852 18.2965C16.3229 18.3899 16.3791 18.4747 16.4503 18.546C16.5215 18.6172 16.6064 18.6733 16.6997 18.711C16.7931 18.7488 16.8932 18.7673 16.9939 18.7655C17.0946 18.7637 17.1939 18.7417 17.2859 18.7007C17.3779 18.6597 17.4607 18.6006 17.5293 18.5269L19.5293 16.5269C19.6698 16.3863 19.7487 16.1957 19.7487 15.9969C19.7487 15.7982 19.6698 15.6075 19.5293 15.4669L17.5293 13.4669C17.3887 13.3265 17.1981 13.2476 16.9993 13.2476C16.8006 13.2476 16.61 13.3265 16.4693 13.4669Z" fill="white" fillOpacity="0.9"/>
          </svg>
          <p className='green battery'>
            { newBid || "" }
            { swappedBatterySoc ? <p className='soc'> SOC: {swappedBatterySoc} </p> : null}
          </p>
          <p className='date'>{ formattedDate }</p>
        </div>
      </div>
    )
  };

  const distParser = { x: "label", y: "count", yUnit: "km", yLabel: "Average Distance / Day", xLabel: "Days" };
  const timeParser = { x: "label", y: "count", yUnit: "hrs", yLabel: "Average Time / Day", xLabel: "Days" };
  const speedParser = { x: "label", y: "count", yUnit: "km/hr", yLabel: "Average Speed / Day", xLabel: "Days" };
  const emissionParser = { x: "label", y: "count", yUnit: "kgs", yLabel: "Average Emission / Day", xLabel: "Days" };

  const axisStyles = {
    x: {
      title: { color: "#FFFFFF33", font: { size: "13px", weight: 400 }, padding: { top: 14 } },
      ticks: { autoSkip: false, maxRotation: 90 },
    },
    y: {
      title: { color: "#FFFFFF33", font: { size: "13px", weight: 400 }, padding: { bottom: 14 } },
    },
  };

  const distanceStats = useMemo(() => {
    const distanceData = vehicleStats || [];

    let [ dataset, total, average ] = generateDatasetForDays(30, distanceData, "dst", 1000, DATASET_COLORS.ORANGE);
    setAvgDistanceStats(old => ({ ...old,  avDist: (average / 1000), totalDist: (total / 1000) }))

    return dataset;
  }, [vehicleStats]);

  const timeStats = useMemo(() => {
    const timeData = vehicleStats || [];
    if (!timeData.length) return setAvgTimeStats(old =>  ({ ...old, avTime: 0, totalTime: 0 }));

    let [ dataset, total, average ] = generateDatasetForDays(30, timeData, "dur", 60 * 60, DATASET_COLORS.SUCCESS);
    setAvgTimeStats(old =>  ({ ...old, avTime: (average / (60 * 60)), totalTime: total / (60 * 60) }));

    return dataset;
  }, [vehicleStats]);

  const speedStats = useMemo(() => {
    const speedData = vehicleStats || [];

    let [ dataset, total, average, points ] = generateDatasetForDays(30, speedData, "avs", 1, DATASET_COLORS.CYAN);
    let topSpeed = Math.max(...points.map(({ tps }) => tps));
    if (!isFinite(topSpeed)) topSpeed = 0;
    setAvsSpeedStats(old =>  ({ ...old, avSpeed: (average), totalSpeed: total, topSpeed: topSpeed }))

    return dataset;
  }, [vehicleStats]);

  const emissionStats = useMemo(() => {
    const emissionData = vehicleStats || [];
    const CARBON_EMISSION_CONSTANT = updateCarbonEmissionConstant ? MANUFATURING_CO2_EMISSION_PER_KM : CO2_EMISSION_PER_KM;

    let [ dataset, total, average ] = generateDatasetForDays(30, emissionData, "dst", 1, DATASET_COLORS.PURPLE);
    setAvsEmissionStats(old =>  ({ ...old, avEmission: ((average / 1000) * CARBON_EMISSION_CONSTANT), totalEmission: ((total / 1000) * CARBON_EMISSION_CONSTANT), }))
    dataset.forEach(set => {
      set.count = (set.count / 1000) * CARBON_EMISSION_CONSTANT;
    });

    return dataset;
  }, [ vehicleStats, updateCarbonEmissionConstant ]);

  const handleBatterySwap = () => {
    if (!newBattery || newBattery === "-") return setModalError("Please enter new battery number");
    else if (newBattery === vehicleDetails.bId) return setModalError("New battery number is same as current battery number");

    swapBattery({ idx: vid, oldBid: vehicleDetails.bId, newBid: newBattery }, (err) => {
      if (err) {
        setModalError(err);
      } else {
        const newSwappingHistory = [ {
          oldBid: vehicleDetails.bId,
          newBid: newBattery,
          ts: Date.now(),
        }, ...swappingHistory ];

        setSwappingHistory(newSwappingHistory)
        setVehicleDetails(oldVeh => ({ ...oldVeh, bId: newBattery }))

        setShowSwappingModal(false);
        setModalError("");
        setShowSuccessModal(true);
        setNewBattery("");
      }
    });
  }

  if (distanceStats && timeStats && speedStats) {
    let dateRange = 30;
    if (isSpecificVehicleStats && filters.range === DATE_OPTIONS.YESTERDAY) dateRange = 1;
    else if (isSpecificVehicleStats && filters.range === DATE_OPTIONS.LAST_7_DAYS) dateRange = 7;
    graphCards = [
      {
        title: "Distance Travelled",
        averageStats: {
          labelFirst: {
            label: "Average Distance / Day",
            value: `${avgDistanceStats.avDist ? Math.floor(avgDistanceStats.avDist).toLocaleString() : 0}km`,
          },
          labelSecond: {
            label: `Total Distance (Last ${dateRange} day${dateRange > 1 ? "s" : ""})`,
            value: `${avgDistanceStats.totalDist ? Math.floor(avgDistanceStats.totalDist).toLocaleString() : 0}km`,
          },
          labelThird: {
            label: "Total Distance (Lifetime)",
            value: `${avgDistanceStats.lifeTimeDist ? Math.floor(avgDistanceStats.lifeTimeDist).toLocaleString() : 0}km`,
          },
        },
        parser: distParser,
        stats: distanceStats,
        axisStyles: axisStyles,
        formatter: (distance) => `${Number(distance).toFixed(2)} km`,
      },
      {
        title: "Time Travelled",
        averageStats: {
          labelFirst: {
            label: "Average Time / Day",
            value: secondsToHms((avgTimeStats.avTime || 0) * 60 * 60),
          },
          labelSecond: {
            label: `Total Time (Last ${dateRange} day${dateRange > 1 ? "s" : ""})`,
            value: secondsToHms((avgTimeStats.totalTime || 0) * 60 * 60),
          },
          labelThird: {
            label: "Total Time (Lifetime)",
            value: secondsToHms(avgTimeStats.lifeTime || 0),
          },
        },
        parser: timeParser,
        stats: timeStats,
        axisStyles: axisStyles,
        formatter: (duration) => secondsToHms(duration * 60 * 60),
      },
      {
        title: "Speed",
        tooltipTitle: "Average Speed",
        averageStats: {
          labelFirst: {
            label: "Average Speed",
            value: `${avSpeedStats.avSpeed ? Math.floor(avSpeedStats.avSpeed).toLocaleString() : 0}km/hr`,
          },
          labelSecond: {
            label: `Top Speed Distance (Last ${dateRange} day${dateRange > 1 ? "s" : ""})`,
            value: `${avSpeedStats.topSpeed ? Math.floor(avSpeedStats.topSpeed).toLocaleString() : 0}km/hr`,
          },
          labelThird: {
            label: "Top Speed (Lifetime)",
            value: `${avSpeedStats.lifeTimeTopSpeed ? Math.floor(avSpeedStats.lifeTimeTopSpeed).toLocaleString() : 0}km/hr`,
          },
        },
        parser: speedParser,
        stats: speedStats,
        axisStyles: axisStyles,
        formatter: (speed) => `${Number(speed).toFixed(2)} km/hr`,
      },
      {
        title: "CO₂ Emission Saved",
        tooltipTitle: "Average CO₂ Emission",
        averageStats: {
          labelFirst: {
            label: "Today",
            value: `${avsEmissionStats.avEmission ? (avsEmissionStats.avEmission.toFixed(2)).toLocaleString() : 0}kg`,
          },
          labelSecond: {
            label: "Last 30 days",
            value: `${avsEmissionStats.totalEmission ? (avsEmissionStats.totalEmission.toFixed(2)).toLocaleString() : 0}kg`,
          },
          labelThird: {
            label: "Lifetime",
            value: `${avsEmissionStats.lifeTimeEmission ? ((avsEmissionStats.lifeTimeEmission * (updateCarbonEmissionConstant ? MANUFATURING_CO2_EMISSION_PER_KM : CO2_EMISSION_PER_KM)).toFixed(2)).toLocaleString() : 0}kg`,
          },
        },
        parser: emissionParser,
        stats: emissionStats,
        axisStyles: axisStyles,
        formatter: (emission) => `${Number(emission).toFixed(2)}kgs`,
        showCheckbox: true,
        checkboxLabel: "Include Emission saved during manufacturing",
        checked: updateCarbonEmissionConstant,
        handleCheckbox: () => setUpdateCarbonEmissionConstant(!updateCarbonEmissionConstant),
      },
    ]
  }

  const handleVehicleRemove = (vehicle) => {
    removeVehicle(filters.client, vehicle, (err, resp) => {
      if (err) console.error(err);
      else {
        setShowRemoveVehicleFromLeaseModal(null);
        Toast({ isClosable: true, description: "Vehicle removed from Lease successfully", position: "bottom", status: "success", variant: "solid" });
        navigate("/lease/vehicles");
      }
    })
  }

  const removeVehicleFromLease = () => {
    setShowRemoveVehicleFromLeaseModal({
      open: true,
      modalMsg: "Are you sure you want to remove this vehicle from lease?",
      confirmBtn: "Yes",
      closeBtn: "Cancel",
      onConfirm: () => handleVehicleRemove(vehicleDetails.idx),
      onModalClose: () => setShowRemoveVehicleFromLeaseModal(null),
    })
  }

  const handlePastRides = () => {
    if (isSellerOrDealer) navigate(`${PATHS.LIVE_TRACKING}/${PATHS.PAST_RIDES}/${vehicle}?reg=${vehicleDetails.reg}`);
    else navigate(`${PATHS.LEASED_VEHICLES}/${PATHS.PAST_RIDES}/${vehicle}?reg=${vehicleDetails.reg}`);
  };

  const initListeners = useCallback(() => {
    if (!global.UWS || !global.UWS.wsConnected) {
      const onWsConnected = () => {
        global.EE.removeEventListener(global.EE.EVENT_TYPES.UWS_CONNECTED, onWsConnected);
        initListeners();
      }

      global.EE.addEventListener(global.EE.EVENT_TYPES.UWS_CONNECTED, onWsConnected);
      return;
    }

    // Add Listeners for relay status
    onWsConnect();
    global.EE.addEventListener(global.EE.EVENT_TYPES.RELAY_STATE, handleLockUnlock);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RELAY, handleLockUnlock);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RELAY_DONE, handleLockUnlock);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RELAY_ERR, handleLockUnlock);
  }, []);


  useEffect(() => {
    initListeners();

    return () => {
      // Remove Listeners for relay status
      global.EE.removeEventListener(global.EE.EVENT_TYPES.RELAY_STATE, handleLockUnlock);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.RELAY, handleLockUnlock);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.RELAY_DONE, handleLockUnlock);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.RELAY_ERR, handleLockUnlock);
    };
  }, [initListeners]);

  const onLockUnlock = () => {
    let action = global.EE.EVENT_TYPES.RELAY_STATE;
    let { uid, did, hwtyp, imei, idx:vid } = vehicleDetails;

    if ( !uid && !did && !hwtyp && !imei && !vid ){
      console.error("onLockUnlock: Mandatory paramters missing ");
      return;
    }

    let isSellerOrDealer = +getItemFromLocalStorage("des");

    let data = { uid, vid, did, hwtyp, imei, state: !lockStatus };
    if (isSellerOrDealer && global.WS && global.WS.wsConnected) {
      global.WS.sendRequest({ action, data });
    } else if (global.UWS && global.UWS.wsConnected) global.UWS.sendRequest({ action, data });
    setIsLockUnlockUpdating(true);
  }

  const userVehLockUnLock = () => {
    let action = global.EE.EVENT_TYPES.RELAY;
    let data = {idx: vehicleDetails.did, state: lockStatus === false ? 1 : 0};

    if (global.UWS && global.UWS.wsConnected) global.UWS.sendRequest({action, data});
    setIsLockUnlockUpdating(true);
  }

  const handleLockUnlock = (data) => {
    if (data.error){
      setShowVehLockUnlockModel(false);
      Toast({ isClosable: true, description: (data.error ? `${data.error} Please try again later` : "Something went wrong"), position: "bottom", status: "error", variant: "solid" });
      return;
    }
    setIsLockUnlockUpdating(false);
  }

  const STATS_CARDS = [
    { title: "Distance Travelled", key: "dst", format: "distance" },
    { title: "Duration", key: "dur", format: "duration" },
    { title: "Top Speed", key: "tps", format: "speed" },
  ];

  const handleVehicleUnassign = () => {
    let vids = [ vehicle ];
    let selected = allSubUsers.find(subuser => subuser.mob === isAssigned);
    if (!selected || !selected.mob) return;
    manageVehicles({ vids, uid: selected.idx, isAssign: false }, (err, success) => {
      if (err) Toast({ isClosable: true, description: `${err} Please try again later!`, position: "bottom", variant: "subtle", duration: 3000 });
      else {
        let updatedSubUsers = allSubUsers.map((subuser) => {
          if (subuser.idx === selected.idx) {
            return {
              ...subuser,
              vehCnt: subuser.vehCnt > 0 ? subuser.vehCnt - 1 : 0,
              vehicles: subuser.vehicles.filter((veh) => !vids.includes(String(veh.idx))),
            };
          }
          return subuser;
        })
        setAllSubUsers(updatedSubUsers);

        searchParams.delete("assigned");
        setSearchParams(searchParams, { replace: true });
        setModalMsg("Vehicle unassigned successfully!");
      }
    });
  }

  const confirmVehicleUnassign = () => {
    setShowConfirmModal({
      open: true,
      modalMsg: `Are you sure you want to unassign this vehicle ${selectedUser && selectedUser.fn ? `from ${selectedUser.fn}` : ""} ?`,
      footer: "confirm-delete-alert",
      closeBtn: "Cancel",
      confirmBtn: "Yes",
      onConfirm: () => handleVehicleUnassign(),
      onModalClose: () => setShowConfirmModal(false),
    });
  }

  useEffect(() => {
    if ((!allSubUsers || !allSubUsers.length) && isAssigned) {
      getUserAndVehicleDetails({}, (err, data = []) => {
        if (err) console.error("Error fetching sub users");
        else {
          let selected = data.find(subuser => subuser.mob === isAssigned);
          if (selected && selected.mob) setSelectedUser(selected);
          setAllSubUsers(data);
        }
      });
    }
  }, [ allSubUsers, setAllSubUsers, isAssigned ]);

  useEffect(() => {
    if (allSubUsers && allSubUsers.length && vehicle && isAssigned) {
      let selectedSubUser = allSubUsers.find(user => user.mob === isAssigned);
      if (selectedSubUser && selectedSubUser.vehicles && selectedSubUser.vehicles.length) {
        let isVehInSubUser =  selectedSubUser.vehicles.find(veh => veh.idx === +vehicle);
        if (isVehInSubUser) setShowUnassign(true);
      }
    }
  }, [ allSubUsers, vehicle, isAssigned ]);

  const onLastSeen = (data) => {
    if (data && data.length) {
      lastSeenRef.current = data[0];
      setLastSeen(data[0]);
    }
  }

  const onWsConnect = () => {
    if (!searchParams.get("isSvs")) return;

    let action =  "getDynamicLastSeen";
    let data = { vids: [ +searchParams.get("idx") ] };
    global.UWS.sendRequest({ action, data });
  }

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_LAST_SEEN, onLastSeen);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.UWS_CONNECTED, onWsConnect);
    }
  }, []);

  useEffect(() => {
    if (vehicleDetails && lastSeenRef.current) {
      setVehicleDetails(old => { return { ...old, lastSeen: lastSeenRef.current }});
    }
  }, [ lastSeen ]);

  useEffect(() => {
    if (!vehicleDetails.did) return;
    const ACCESS_CODES = getItemFromLocalStorage("accessCodes");
    if (!ACCESS_CODES.includes(DRAWER_ACCESS_CODES.PLANS_AND_WARRANTY)) return;
    getUserSubsWarrantyDetails(null, (err, data) => {
      if (err) return;
      const vehs = transformUserDetails(data);
      const match = vehs.find(v => v.did === vehicleDetails.did);
      if (match) setSubsWarrantyInfo(match);
    });
  }, [vehicleDetails.did]);

  return (
    <>
      {!showLoading ?
        <div className='panel-main vehicle-stats'>
          <PopUpModal { ...confirmUnassign } { ...showRemoveVehicleFromLeaseModal } />
          { showSwappingModal &&
            <BatterySwappingModal
              show={showSwappingModal}
              hide={setShowSwappingModal}
              battery={vehicleDetails.bId}
              newBattery={newBattery}
              newBatteryOnChange={setNewBattery}
              modalError={modalError}
              onSubmit={handleBatterySwap}
            />
          }
          { showSuccessModal &&
            <SuccessModal show={showSuccessModal} hide={setShowSuccessModal} /> }
          {
            showVehLockUnlockModel &&
            <VehicleLockUnlockModal
              show={showVehLockUnlockModel}
              vehicleRegNum={vehicleDetails.reg}
              isLoading={isLockUnlockUpdating}
              isLocked={lockStatus}
              onLockUnlock={userRef.current ? userVehLockUnLock :onLockUnlock}
              hide={() => setShowVehLockUnlockModel(false)}
              onSuccess={() => setLockStatus(prev => !prev)}
            />
          }
          <div className='vehicle-stats-header'>
            <div className="breadcrumb-container">
              <Breadcrumb paths={getBreadcrumbPaths()} />
            </div>
            {
              isSpecificVehicleStats &&
              <div className="date-picker-container">
               <DatePicker customMaxDate={getISODate()} onClose={() => getSelectedVehicleStats(vehicleDetails.idx)} />
              </div>
            }
          </div>

          <div className={`remove-from-lease-wrapper ${isSpecificVehicleStats && "mb"}`}>
            {!isSpecificVehicleStats && <>
              {!userRef.current ? <>
                <Button onClick={handlePastRides} className="view-past-rides">View Past Rides</Button>
                {!isSellerOrDealer ? <Button onClick={removeVehicleFromLease} className="remove-from-lease">Remove from Lease</Button> : null}
              </>
              :
              <>
                <Button onClick={() => {navigate(`${PATHS.LIVE_TRACKING}${PATHS.ALL_VEHICLE_STATS}?idx=${vehicle}&isSvs=true&lt=true`); setIsLt(false); setIsSpecificVehicleStats(true)}} className="view-stats">View Statistics</Button>
                <Button onClick={() => navigate(`${PATHS.LIVE_TRACKING}/${PATHS.PAST_RIDES}/${vehicle}?reg=${vehicleDetails.reg}`)} className="view-rides">View Rides</Button>
                {isAssigned && showUnassign ? <Button onClick={confirmVehicleUnassign} variant={"outline"} className="unassign-from-user">Unassign from subuser</Button> : null}
              </>}
            </>}
          </div>

          <div className="vehicles-batteries-container">
            <div className="vehicle-battery-container">
              <div className={`card ${!(swappingHistory && swappingHistory.length && vehicleDetails && vehicleDetails.bId) ? "only-vehicle-details" : ""} ${isSpecificVehicleStats && "vehicle-details-highlightedBg"}`}>
                <div className='vehicle-card-header'>
                  <div className="vehicle-stats-card-header">
                    <Title> Vehicle Details</Title>
                    <Tooltip label="Edit vehicle details">
                      <IconButton onClick={() => navigate(`${PATHS.LIVE_TRACKING}/${PATHS.VEHICLE_STATS}/${PATHS.UPDATE_VEHICLE}${window.location.search}`)} ><EditModelIcon /></IconButton>
                    </Tooltip>
                  </div>
                  <div className="vs-header-right">
                    {subsWarrantyInfo && (() => {
                      const subDays = getDaysLeft(subsWarrantyInfo.subscriptionExpiry);
                      const subPill = getStatusPill(subDays);
                      return (
                        <button className={`vs-status-pill pill-${subPill.color}`} onClick={() => navigate(`${PATHS.PLANS_AND_WARRANTY}/${subsWarrantyInfo.id}`)}>
                          {subPill.text}
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
                        </button>
                      );
                    })()}
                  {
                    (!isSpecificVehicleStats && vehicleDetails && true) ? <div className='toggle-container'>
                      <div className={!lockStatus ? "active-unlock" : "inactive-icon"}>
                        <UnlockIcon />
                        <h2>Unlock</h2>
                      </div>
                      <Switch size='lg' isChecked={lockStatus} onChange={() => setShowVehLockUnlockModel(true)} className={lockStatus ? "toggle-lock" : "toggle-unlock"} />
                      <div className={lockStatus ? "active-lock" : "inactive-icon"}>
                        <LockIcon />
                        <h2>Lock</h2>
                      </div>
                    </div> : null
                  }
                  </div>
                </div>

                {
                  (swappingHistory && swappingHistory.length && vehicleDetails && vehicleDetails.bId) ?
                  <div className="vehicle-details-wrapper">
                    <div className="vehicle-dets-left">
                      {vehicleDetailLeft.map((data, idx) => (
                        <label key={idx}>
                          { data.label }
                          <p>{ data.value || "N/A" }</p>
                        </label>
                      ))}
                    </div>
                    <div className="vehicle-dets-right">
                      {vehicleDetailRight.map((data, idx) => (
                        <label key={idx}>
                          { data.label }
                          <p>{ data.value || "N/A" }</p>
                        </label>
                      ))}
                    </div>
                  </div> :
                  <div className={`vehicle-dets ${isAssigned ? "sub-user-veh" : ""}`}>
                    {(isSpecificVehicleStats || isLt)
                    ?
                    (userRef.current ? vehicleStatsDetails.filter(veh => !veh.isSellerOnly) : vehicleStatsDetails).map((data, idx) => {
                      if (data.isAssignOnly && !isAssigned) return <></>
                      else return (
                        <p className="kv" key={idx}>
                          <span className="key">{data.label}</span>
                          <span className="val">{data.value && data.constants && data.constants[data.value] ? data.constants[data.value] : (data.value || "N/A")}</span>
                        </p>
                     )
                    })
                    :
                    vehicleDetail.map((data, idx) => (
                       <p className="kv" key={idx}>
                         <span className="key">{data.label}</span>
                         <span className="val">{data.value || "N/A"}</span>
                       </p>
                    ))}
                  </div>
                }
              </div>

              { (swappingHistory && swappingHistory.length && vehicleDetails && vehicleDetails.bId) ?
                <div className="card">
                  <div className="battery-swaping">
                   <Title>Battery Swapping</Title>
                   { (vehicleDetails && vehicleDetails.bId) || true ? <Button onClick={() => setShowSwappingModal(true)} className='swap-battery'>
                     Swap this Vehicle's Battery
                  </Button> : null }
                   </div>
                 <div className="swapping-timeline">
                  { swappingHistory && swappingHistory.length ?
                    <Timeline
                      timelineData={swappingHistory}
                      TimelineCardComp={TimelineCard}
                    /> : <p className="no-swapping-history">No Swapping History found!</p> }
                 </div>
                 </div> : <></>
              }
            </div>
            {
              isSpecificVehicleStats && <div className="stat-card-container">
              {
               STATS_CARDS.map((stat)=>{
                 return <StatsCard key={stat.key} title={stat.title} format={stat.format} value={(!vehicleStats || !vehicleStats.length) ? 0 : stats[stat.key]}/>
               })
              }
             </div>
            }


            {(!isSpecificVehicleStats && vehicleDetails.idx) && ( <TodayRide singleDevPage={!!isSellerOrDealer.current} devType={vehicleDetails.hwtyp || 1} vehicleDetails={vehicleDetails} vid={vehicleDetails.idx} vehicleStats={vehicleStats}/>)}

            {(isSpecificVehicleStats && stats && stats.ridingScoreDetails && stats.ridingScoreDetails.rideScore && vehicleStats && vehicleStats.length) ? <RidingScore ridingScoreDetails={stats.ridingScoreDetails} showOnlyRidingEvents={isSpecificVehicleStats ? true : false}/> : null}

            {/* <RidingScore ridingScoreDetails={overAllStats} showOnlyRidingEvents={isSpecificVehicleStats ? true : false}/> */}

            { isSpecificVehicleStats && graphCards && graphCards.length ?
              <div className="info-note">
                <InfoIconBgFilled />
                <span className="note-msg">
                  {
                    filters.range === DATE_OPTIONS.YESTERDAY
                    ? "Below graph shows yesterday's data."
                    : filters.range === DATE_OPTIONS.LAST_7_DAYS
                    ? "Below graph shows last 7 days data."
                    : "Below graph shows last 30 days data."
                  }
                </span>
              </div>
            : null }

            {(((userRef.current || isSellerOrDealer) && !isLt) || (isLt && isSpecificVehicleStats)) ? <>
            {graphCards && graphCards.length
              ? (isSpecificVehicleStats ? graphCards.slice(0,3).map((card, idx) => <StatCard key={idx} card={card} />) : graphCards.map((card, idx) => <StatCard key={idx} card={card} />))
              : null}
            </> : null}
          </div>
        </div>
      : <Loader hide={true} />}

      <SuccessPopupModal
        open={!!modalMsg}
        modalMsg={modalMsg}
        closeBtn={"Okay"}
        modalSize={"lg"}
        onModalClose={() => {setModalMsg(""); setShowConfirmModal(false)}}
      />

      <PopUpModal { ...showConfirmModal } />
    </>
  )
}

export default VehicleStats
